import { Traits } from './Traits';
import { SlotTraitInfo } from './SlotTraitInfo';
var ExceptionInfo = /** @class */ (function () {
    function ExceptionInfo(abc, start, end, target, multiname, type) {
        this.abc = abc;
        this.start = start;
        this.end = end;
        this.target = target;
        this.multiname = multiname;
        this.type = type;
        this.catchPrototype = null;
        this._traits = null;
        // ...
    }
    ExceptionInfo.prototype.getTraits = function () {
        if (!this._traits)
            this._traits = new Traits([new SlotTraitInfo(this.abc, 0 /* TRAIT.Slot */, this.multiname, 1, this.type, 0, 0)]);
        return this._traits;
    };
    return ExceptionInfo;
}());
export { ExceptionInfo };
